module.exports = {"654026100":"昭苏镇","654026101":"喀夏加尔镇","654026102":"阿克达拉镇","654026103":"喀拉苏镇","654026104":"洪纳海镇","654026201":"乌尊布拉克乡","654026203":"萨尔阔布乡","654026206":"察汗乌苏蒙古族乡","654026207":"夏特柯尔克孜族乡","654026208":"胡松图喀尔逊蒙古族乡","654026513":"兵团七十四团","654026514":"兵团七十五团","654026515":"兵团七十六团","654026516":"兵团七十七团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654026.json
// module id = 3275
// module chunks = 0